import { enumParser } from '#validation/common/parsers';
import { SsoLoginRequirement } from '../constants/sso-login-requirement';
export const ssoLoginRequirementParser = enumParser(SsoLoginRequirement);
